import React from "react";
import PropTypes from 'prop-types';
import "./avatarGroup.scss";
function URAvatarGroup(props: any) {
  let {className, profileInfo } = props;
  return (
    <>
      <div className={className}>{profileInfo}</div>
    </>

  );
}

export {
  URAvatarGroup
};

URAvatarGroup.propTypes = {
  className: PropTypes.any,
  profileInfo: PropTypes.any
};